(function () {
  'use strict';

  var PRIMARY_HANDLE = 'turkish-printed-rayon-viscose-jacquard-fabric';
  var SECONDARY_HANDLE = 'printed-rayon-viscose-jacquard-170-gsm';
  var LEGACY_SECONDARY_HANDLE = 'turkish-printed-rayon-viscose-jacquard-fabric-kopya';
  var MILANO_HANDLE = 'milano-matte-sandwashed-silky-fabric';
  var LINEN_HANDLE = 'linen-viscose-jacquard-fabric';

  (function installP2ConsolidationCompatibility() {
    if (window.__hibaP2ConsolidationFetchCompat === true) return;
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var handle = match ? decodeURIComponent(match[1]) : '';
    if (handle !== PRIMARY_HANDLE || typeof window.fetch !== 'function') return;

    var legacyByVariant = {
      '45322155983030': ['D# 2290', 'C# 2290-V1-Black'],
      '45322156048566': ['D# 2290', 'C# V7-Brown'],
      '45322156114102': ['D# 2290', 'C# V11-White'],
      '45322156179638': ['D# 2290', 'C# V10-Navy Blue'],
      '45322156245174': ['D# 1941', 'C# V4-Black'],
      '45322156310710': ['D# 1941', 'C# V5-Brown'],
      '45322156376246': ['D# 1945', 'C# 1945-V2-White'],
      '45322156441782': ['D# 1945', 'C# 1945-V1-Black'],
      '45322156507318': ['D# 2480', 'C# 2480-V1-Black'],
      '45322156572854': ['D# 2480', 'C# 2480-V2-Brown'],
      '45322156605622': ['D# 2480', 'C# V12-Navy Blue'],
      '45322156671158': ['D# 2542', 'C# V36-Bordo'],
      '45322156736694': ['D# 2542', 'C# V35-Brown'],
      '45322156802230': ['D# 2542', 'C# V28-Black'],
      '45411368599734': ['D# 1957', 'P2::45411368599734'],
      '45411370827958': ['D# 1957', 'P2::45411370827958'],
      '45411373678774': ['D# 1957', 'P2::45411373678774'],
      '45411377184950': ['D# 1957', 'P2::45411377184950']
    };

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isSecondaryJson =
        url.indexOf('/products/' + SECONDARY_HANDLE + '.js') !== -1 ||
        url.indexOf('/products/' + LEGACY_SECONDARY_HANDLE + '.js') !== -1;
      var request = originalFetch.apply(this, args);
      if (!isSecondaryJson) return request;

      return request.then(function (response) {
        if (!response || !response.ok) return response;
        return response.clone().json().then(function (product) {
          if (!product || !Array.isArray(product.variants)) return response;
          product.variants.forEach(function (variant) {
            var legacy = legacyByVariant[String(variant.id || '')];
            if (!legacy) return;
            if (Array.isArray(variant.options)) {
              variant.options = variant.options.slice();
              variant.options[0] = legacy[0];
              variant.options[1] = legacy[1];
            }
            variant.option1 = legacy[0];
            variant.option2 = legacy[1];
          });
          return new Response(JSON.stringify(product), {
            status: response.status,
            statusText: response.statusText,
            headers: { 'Content-Type': 'application/json' }
          });
        }).catch(function () { return response; });
      });
    };

    window.__hibaP2ConsolidationFetchCompat = true;
    window.__hibaP2ConsolidationFetchCompatVersion = '20260908-mini-palm-v3';
  })();

  var current = document.currentScript && document.currentScript.src;
  if (!current) return;
  var clean = current.split('?')[0];
  var base = clean.replace(/hiba-primary-roll-swatch-fix\.js$/, '');
  var version = '20260914-milano-all-color-gallery-v2-fullbleed';
  var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var pageHandle = pathMatch ? decodeURIComponent(pathMatch[1]) : '';

  function load(filename, done) {
    var script = document.createElement('script');
    script.src = base + filename + '?v=' + version;
    script.async = false;
    script.onload = done || function () {};
    script.onerror = done || function () {};
    document.head.appendChild(script);
  }

  if (pageHandle === LINEN_HANDLE) {
    load('hiba-linen-viscose-plain-reconciliation-test.js');
  }

  function loadPrimaryChain() {
    load('hiba-square-color-preflight.js', function () {
      load('hiba-primary-roll-swatch-fix.backup-before-final37-gallery.js', function () {
        load('hiba-square-native-duplicate-guard.js', function () {
          load('hiba-square-primary-roll-router.js', function () {
            load('hiba-square-six-image-gallery.js', function () {
              load('hiba-primary-roll-final37-gallery.js', function () {
                load('hiba-primary-roll-gallery-controller-v2.js', function () {
                  if (pageHandle === SECONDARY_HANDLE || pageHandle === LEGACY_SECONDARY_HANDLE) {
                    load('hiba-p1-featured-image-anchor-compat.js', function () {
                      load('hiba-cross-product-reverse-wrapper.js', function () {
                        load('hiba-cross-product-gallery-ownership.js');
                      });
                    });
                  } else if (pageHandle === PRIMARY_HANDLE) {
                    load('hiba-cross-product-gallery-ownership.js');
                  }
                });
              });
            });
          });
        });
      });
    });
  }

  if (pageHandle === MILANO_HANDLE) {
    load('hiba-milano-all-color-gallery.js', function () {
      load('hiba-milano-fullbleed-layout-fix.js');
    });
  } else {
    loadPrimaryChain();
  }
})();
